import "./FileManager2.scss"
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {prepareRaikoSelectBoxItem, RaikoSelectBox} from "../../raikoComponents/raikoSelectBox/RaikoSelectBox";
import {FileManagerTypes, fileTypes} from "../../component/fileManager/FileManager";
import {css} from "@emotion/css";
import {FileManagerService} from "../../component/fileManager/FileManagerService";
import MediaItemsModel from "./mediaItemsPicture/MediaItemsModel";
import MediaItemShimmer from "./mediaItemShimmer/MediaItemShimmer";
import UploadVideoFile from "./uploadVideoFile/UploadVideoFile";
import UploadImageFile from "./uploadImageFile/UploadImageFile";
import UploadAudioFile from "./uploadAudioFile/UploadAudioFile";
import {
    DialogSize,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoLabel,
    showErrorMessage,
    RaikoTableTitleContainer, RaikoErrorSection
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RaikoErrorSectionVectors} from "../../util/RaikoErrorSectionVectors";


export default function FileManager2(
    {
        buckets = fileManagers
    }) {

    let page = 0
    const size = 15

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [selectedBucketId, setSelectedBucketId] = useState("");
    const [filterItems, setFilterItems] = useState([]);

    const [itemsCount, setItemsCount] = useState(0);
    const [fileItems, setFileItems] = useState([]);
    const [fileManagerItemsLoadingState, setFileManagerItemsLoadingState] = useState(true);

    const service = new FileManagerService()

    useEffect(() => {
        initialFilters()
    }, [buckets]);

    function initialFilters() {
        setFilterItems([])
        buckets.map((item, index) => {
            setFilterItems(prevState => [
                ...prevState,
                prepareRaikoSelectBoxItem(
                    item.id,
                    item.name
                )
            ])
        })

        setSelectedBucketId(buckets[0].id)
    }

    useEffect(() => {
        if (selectedBucketId && selectedBucketId.length > 0) {
            getFilesFromServer()
        }
    }, [selectedBucketId]);

    function getFilesFromServer() {
        setFileManagerItemsLoadingState(true)
        setItemsCount(0)

        service.getFiles(
            FileManagerTypes[selectedBucketId].url,
            page, size
        ).then(response => {
            setItemsCount(response.numberOfItems)
            setFileItems([])
            response.data.map((item, index) => {
                setFileItems(prev => [
                    ...prev,
                    {
                        name: item.realName,
                        id: item.id,
                        size: item.size,
                        uploadedAt: item.uploadedAt,
                        uploadedBy: item.uploadedBy,
                        url: item.url,
                    }
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setFileManagerItemsLoadingState(false)
        })
    }


    function detectFileType() {


        return fileItems.map((item, index) => {
            return <MediaItemsModel
                id={item.id}
                name={item.name}
                url={item.url}
                size={item.size}
                uploadedAt={item.uploadedAt}
                uploadedBy={item.uploadedBy}
                type={FileManagerTypes[selectedBucketId].type}
                refreshList={_ => {
                    getFilesFromServer()
                }}
                fileManagerUrl={FileManagerTypes[selectedBucketId].url}
            />
        })
    }

    const [uploadVideoDialog, setUploadVideoDialog] = useState(false);
    const [uploadAudioDialog, setUploadAudioDialog] = useState(false);
    const [uploadImageDialog, setUploadImageDialog] = useState(false);


    function handleUploadNewFile() {
        switch (FileManagerTypes[selectedBucketId].type) {
            case fileTypes.VIDEO:
                setUploadVideoDialog(true)
                break;
            case fileTypes.IMAGE:
                setUploadImageDialog(true)
                break;
            case fileTypes.AUDIO:
                setUploadAudioDialog(true)
                break;

        }
    }

    function handleRefreshList(newItem) {
        setItemsCount(itemsCount + 1)

        if (uploadImageDialog) {
            setUploadImageDialog(false)
            setFileItems(prev => [
                {
                    name: newItem.realName,
                    id: newItem.id,
                    size: newItem.size,
                    uploadedAt: newItem.uploadedAt,
                    uploadedBy: newItem.uploadedBy,
                    url: newItem.url,
                },
                ...prev
            ])
        } else {
            setUploadVideoDialog(false)
            setUploadAudioDialog(false)

            setFileItems(prev => [
                {
                    name: newItem.fileName,
                    id: newItem.id,
                    size: newItem.size,
                    uploadedAt: newItem.uploadedAt,
                    uploadedBy: newItem.uploadedBy,
                    url: newItem.streamUrl,
                },
                ...prev
            ])
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.Files.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadAudioDialog(false)
                }}
                open={uploadAudioDialog}
                pageTitle={"بارگزاری صوت جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadAudioFile handleRefreshList={handleRefreshList}/>

            </RaikoDefaultDialogPage>

            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadVideoDialog(false)
                }}
                open={uploadVideoDialog}
                pageTitle={"بارگزاری ویدیو جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadVideoFile handleRefreshList={handleRefreshList}/>

            </RaikoDefaultDialogPage>

            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadImageDialog(false)
                }}
                open={uploadImageDialog}
                pageTitle={"بارگزاری تصویر جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadImageFile
                    handleRefreshList={handleRefreshList}
                    uploadUrl={selectedBucketId && selectedBucketId.length > 0 ? FileManagerTypes[selectedBucketId].uploadUrl : ""}/>

            </RaikoDefaultDialogPage>

            <RaikoBaseContainer className={"baseFileManagerContainer"}>

                <RaikoGridOneColumn className={css`gap: 2.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator("مجله", ""),
                        raikoBreadCrumbItemGenerator(selectedBucketId && selectedBucketId.length > 0 ? FileManagerTypes[selectedBucketId].name : "", ""),
                    ]}/>

                    <RaikoGridOneColumn>
                        <RaikoLabel text={"دسته ها"}/>
                        <RaikoSelectBox
                            changeSelectItem={setSelectedBucketId}
                            items={filterItems}
                            defaultSelectedItem={selectedBucketId}
                        />
                    </RaikoGridOneColumn>

                    <RaikoTableTitleContainer
                        title={"فایل ها"}
                        hasCreateNewItem
                        handleCreateNewItem={handleUploadNewFile}
                        amount={itemsCount}
                    />

                    {
                        fileManagerItemsLoadingState ?
                            <MediaItemShimmer/> :
                            fileItems && fileItems.length > 0 && !fileManagerItemsLoadingState ?
                                <RaikoGridOneColumn className={css`gap: .75rem`}>
                                    {detectFileType()}
                                </RaikoGridOneColumn>
                                :
                                <RaikoErrorSection
                                    errorType={RaikoErrorSectionVectors.EMPTY_LIST_ONE}
                                    subTitle={""}
                                />
                    }

                </RaikoGridOneColumn>

            </RaikoBaseContainer>

        </>
    )
}


const fileManagers = [
    FileManagerTypes.NEWS_THUMBNAILS,
    FileManagerTypes.PROJECT_IMAGES,
    // FileManagerTypes.POST_VIDEOS,
    // FileManagerTypes.POST_AUDIOS,
    // FileManagerTypes.APK,
]